import keyMirror from 'keymirror';
import i18n from 'i18next';

export const exerciseDetailsActionTypes = keyMirror({
	START_EXERCISE_REQUEST: null,
	START_EXERCISE_REQUEST_SUCCESS: null,
	START_EXERCISE_REQUEST_ERROR: null,

	RESTART_EXERCISE_REQUEST: null,
	RESTART_EXERCISE_REQUEST_SUCCESS: null,
	RESTART_EXERCISE_REQUEST_ERROR: null,

	SET_SELECTED_ITEMS: null,

	SET_CURRENT_LIST_ID: null,

	SKIP_ONBOARDING_REQUEST: null,
	SKIP_ONBOARDING_SUCCESS: null,
	SKIP_ONBOARDING_ERROR: null,

	SET_START_EXERCISE: null,

	SEND_ANSWER_REQUEST: null,
	SEND_ANSWER_SUCCESS: null,
	SEND_ANSWER_ERROR: null,

	CLEAR_STATE: null,

	SAVE_SETTINGS_REQUEST: null,
	SAVE_SETTINGS_SUCCESS: null,
	SAVE_SETTINGS_ERROR: null,

	SET_HINT_TYPE: null,

	SAVE_SUBTYPE_REQUEST: null,
	SAVE_SUBTYPE_SUCCESS: null,
	SAVE_SUBTYPE_ERROR: null,

	RESUME_PAUSED_EXERCISE_REQUEST: null,
	RESUME_PAUSED_EXERCISE_SUCCESS: null,
	RESUME_PAUSED_EXERCISE_ERROR: null,

	SET_EXERCISE_SCORE: null,

	SET_IS_RESTART: null,
	TOGGLE_SETTINGS_MODAL: null,
	HANDLE_EXERCISE_TYPES: null,

	HANDLE_WORDS_TYPO_CHECKER_SUCCESS: null,
	HANDLE_WORDS_TYPO_CHECKER: null,
});

export const exerciseDescriptions = () => ({
	multiple_choice: i18n.t('exercise.onboarding_desc.multiple_choice'),
	in_your_mind: i18n.t('exercise.onboarding_desc.in_your_mind'),
	hints: i18n.t('exercise.onboarding_desc.hints'),
	timed: i18n.t('exercise.onboarding_desc.timed'),
	dictate: i18n.t('exercise.onboarding_desc.dictate'),
	full_word: i18n.t('exercise.onboarding_desc.full_word'),
	learn: i18n.t('exercise.onboarding_desc.learn'),
});

export const charactersSize = {
	UPPERCASE: 'uppercase',
	LOWERCASE: 'lowercase',
};

export const exerciseConstants = {
	MIN_TIME_TO_NEXT_WORD: '1000',
	TIME_FOR_HIDE_WORD_IN_SPELLING: '1800',
	VOWELS: ['a', 'e', 'i', 'o', 'u'],
};

export const hintTypes = () => [
	{
		value: 'puzzle',
		title: i18n.t('exercise.hint_types.puzzle.title'),
		description: i18n.t('exercise.hint_types.puzzle.desc'),
	},
	{
		value: 'vowels',
		title: i18n.t('exercise.hint_types.vowels.title'),
		description: i18n.t('exercise.hint_types.vowels.desc'),
	},
	{
		value: 'first_letter',
		title: i18n.t('exercise.hint_types.first_letter.title'),
		description: i18n.t('exercise.hint_types.first_letter.desc'),
	},
];

export const ORIGINAL_WORD_INDEX = 0;
export const TRANSLATION_WORD_INDEX = 1;

export const DIACRITICS_CONV = [
	['%u00df', 'ss'],
	['%u1e9e', 'SS'],
	['%u00e6', 'ae'],
	['%u00c6', 'AE'],
	['%u0153', 'oe'],
	['%u0152', 'OE'],
];

export const DIACRITICS_REGEXP = new RegExp(
	`[${unescape(DIACRITICS_CONV.map((a) => a[0]).join(''))}]`,
	'g',
);

export const FIND_BRACKETS_REGEXP = /\(.*?\)/g;

export const OPTIONS_FOR_REPEATING = [
	{ value: 1, title: 1 },
	{ value: 2, title: 2 },
	{ value: 3, title: 3 },
	{ value: 4, title: 4 },
];

export const getCombinedLanguageOptions = (t) => [
	{
		locale: 'definition',
		name: t('general.meaning_c'),
	},
	{
		locale: 'term',
		name: t('general.understanding'),
	},
];
